import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useGetProductList } from "../../../api/queries/productQueries";
import ProdCard from "../../../components/box/ProdCard";
import { LvlFilterBox } from "../../../components/layout/LvlFilterBox";
import { LvlPagi } from "../../../components/layout/LvlPagi";
import { UiDropdown } from "../../../components/dropdown/UiDropdown";
import { icArrowDown2, icAsset } from "../../../components/image/image-src";

const sortByOptions = [
  "Recommended",
  "Cheapest",
  "Recently hot",
  "Kid-friendly",
];

const PassListView: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSort, setCurrentSort] = useState("Recommended");
  const [ticketData, setPassData] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const location = useLocation();
  const itemsPerPage = 12;
  const searchParams = new URLSearchParams(location.search);
  const city = searchParams.get("city") || "";
  const category = searchParams.get("category") || "";
  const subCategory = searchParams.get("subCategory") || "";
  const keyword = searchParams.get("keyword") || "";
  const type = "PASS";
  const { t } = useTranslation();
  const { data } = useGetProductList({
    city,
    category,
    subCategory,
    keyword,
    type,
  });

  useEffect(() => {
    setPassData([]);

    const fetchPass = () => {
      if (data && data.length > 0) {
        setPassData(data);
        setTotalPages(Math.ceil(data.length / itemsPerPage));
      }
    };

    fetchPass();
  }, [data, currentPage, location.search]);

  const paginatedPasss = ticketData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };
  const renderFilter = () => {
    return (
      <div className="group relative">
        <button className="relative flex items-center gap-[0.5625rem] border-b border-[#83929D]">
          <p className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
            {t("Sort")}
          </p>
          <img
            className="h-[0.8125rem] w-[0.8125rem]"
            src={icArrowDown2}
            alt=""
          />
        </button>
        <UiDropdown>
          <ul>
            {sortByOptions.map((category) => (
              <li
                key={category}
                className={`h-12 cursor-pointer content-center p-3 ${
                  category === currentSort ? "bg-primary" : ""
                }`}
                onClick={() => setCurrentSort(category)}
              >
                {t(category)}
              </li>
            ))}
          </ul>
        </UiDropdown>
      </div>
    );
  };
  const handleCheckboxChange = (
    value: string,
    setSelected: React.Dispatch<React.SetStateAction<string[]>>,
  ) => {
    setSelected((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((item) => item !== value)
        : [...prevSelected, value],
    );
  };
  return (
    <div className="flex gap-[1.125rem]">
      {/* Left Section - Filters */}

      <section className="flex-1">
        <LvlFilterBox text={`${ticketData.length} ${t("pass found")}`}>
          {renderFilter()}
        </LvlFilterBox>
        <div className="grid gap-x-6 gap-y-[1.875rem] sm:grid-cols-3">
          {ticketData.length === 1 && <div className="dummy" />}
          {ticketData.map((ticket) => (
            <ProdCard
              className="!w-full"
              key={ticket.id}
              {...ticket}
              loading="lazy"
            />
          ))}
        </div>

        <LvlPagi
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </section>
    </div>
  );
};

export default PassListView;
